
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import EmailPopup from "./components/feature/EmailPopup";

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AppRoutes />
      <EmailPopup />
    </BrowserRouter>
  );
}

export default App;
